export default __webpack_public_path__ + "static/media/SKS_Medical_Documents.70c4538e.svg";